import { Redirect, Route, Switch } from "react-router-dom";
import ErrorPage from "./errorPage";
import FileUpload from "./fileUpload";
import PhoneVerify from "./phoneVerify";
import ResultPage from "./resultPage";

export default function Octopus() {

  return (
    <Switch>
      <Redirect exact path="/octopus/:token" to="/octopus/verify/:token" />
      <Route path="/octopus/verify/:token">
        <PhoneVerify />
      </Route>
      <Route path="/octopus/upload/:token">
        <FileUpload />
      </Route>
      <Route path="/octopus/result/:token">
        <ResultPage />
      </Route>
      <Route path="/octopus/error/:token">
        <ErrorPage />
      </Route>
    </Switch>
  );
}
